import { TicketTypes } from './ticket-types.model';
import { GCAttributeValue, AttributeName, AttributeNames, AttributeNameValues } from './createattribute.model';
import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';




@Injectable()
export class CreateAttributeService {
    private pkurl = 'api/QualityAttribute';
    private rfurl = 'api/QualityAttribute/getbyname'
    private courl = 'api/QualityAttributeValue';

    constructor(private httpclient: HttpClient) { }

    createQualityAttribute(attributeName: AttributeName, state: string) {
        return this.httpclient.post(`${this.pkurl}?state=${state}`, attributeName);
    }

    getQualityAttributeId(attributeName: string, state: string): Observable<AttributeNames> {
        return this.httpclient.get<AttributeNames>(`${this.rfurl}`, {
            params: { qualityAttributeName: attributeName, state: state }
        });
    }
    createQualityAttributeValues(attributeValues: GCAttributeValue, state: string) {
        return this.httpclient.post(`${this.courl}?state=${state}`, attributeValues);
    }
    getQualityAttributes(state: string): Observable<AttributeNames[]> {
        return this.httpclient.get<AttributeNames[]>(`${this.pkurl}?state=${state}`);
    }

    getQualityAttributeValues(attributeId: number, state: string): Observable<AttributeNameValues[]> {
        return this.httpclient.get<AttributeNameValues[]>(`${this.courl}/${attributeId}?state=${state}`);
    }

    getTicketTypes(token: string, state: string): Observable<TicketTypes[]> {
        return this.httpclient.get<TicketTypes[]>(`${this.courl}/gettickettypes`, { params: { gctoken: token, state: state } });
    }

    getTicketSources(state: string): Observable<string[]> {
        return this.httpclient.get<string[]>(`${this.courl}/getticketsources`, {params: {state: state}});
    }

    deleteQualityAttributeValues(id: number, name: string, state: string) {
        return this.httpclient.delete(`${this.courl}?attributeId=${id}&attributename=${name}&state=${state}`);
    }
}